import React, { useEffect } from 'react'
import { debugEnabled, fullUrl } from '../util'
import { useDispatch, useSelector } from 'react-redux'
import CardImage from './CardImage'
import CardPrices from './CardPrices'
import LazyLoad from 'react-lazyload'
import PropTypes from 'prop-types'
import Spinner from './Spinner'
import { cardProps } from '../props'
import classNames from 'classnames'
import { getCard } from '../store/cardsSlice'
import styles from './Card.module.scss'

const MySpinner = () => (
  <div className={styles.spinnerContainer}>
    <Spinner className={styles.spinner} />
  </div>
)

const Card = ({ name, set, number, onlyBack, onlyFront, reverse, sideBySide, tag, rotate }) => {
  const dispatch = useDispatch()
  const card = useSelector((state) => state.cards[name] || {})
  const { error, image_uris, legal_commander, loaded, pending, prices, typo, url, weird, cardsphere } = card

  useEffect(() => {
    if (!pending && !loaded) dispatch(getCard({ name, tag }))
  }, [])

  const image = (
    <CardImage
      isLoading={!loaded}
      name={name}
      onlyBack={onlyBack}
      onlyFront={onlyFront}
      reverse={reverse}
      sideBySide={sideBySide}
      rotate={rotate}
      srcs={image_uris}
      deckPreview={tag==="deckPreview"}
    />
  )

  return (
    <div
      className={classNames(styles.container, {
        [styles.error]: debugEnabled() && error,
        [styles.sideBySide]: sideBySide,
        [styles.typo]: debugEnabled() && typo,
        [styles.deckPreview]: tag === 'deckPreview',
      })}
    >
      {error ? (
        <div>{error}</div>
      ) : weird ? (
        <>{image}</>
      ) : (
        <a href={fullUrl({ legal_commander, url })} rel='noopener noreferrer' target='_blank'>
          {image}
        </a>
      )}
      {!cardsphere && <CardPrices prices={prices} />}
    </div>
  )
}

const CardContainer = (props) =>
  !props.name ? (
    <MySpinner />
  ) : debugEnabled() ? (
    <div className={styles.image}>
      <Card {...props} />
    </div>
  ) : (
    <LazyLoad className={styles.image} once>
      <Card {...props} />
    </LazyLoad>
  )

CardContainer.propTypes = { ...cardProps, name: PropTypes.string }

export default CardContainer
